import { useCascader } from './useCascader';
import { useCascaderItem } from './useCascaderItem';
export function useCascaderRoot() {
  var cascader = useCascader();
  var rootId = cascader.getRootId();
  return useCascaderItem(rootId);
}